import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getSessionSummary } from 'src/apps/mfa/services/MfaSingleSessionService';
import { SummaryPaneResult } from 'src/apps/mobile-common/types/CommonTypes';
import { MFA_SESSION_SUMMARY } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseMfaSessionSummaryQuery {
	sessionId: string;
}

export const useMfaSessionSummaryQuery = ({
	sessionId
}: IUseMfaSessionSummaryQuery): UseQueryResult<SummaryPaneResult> => {
	const sessionSummaryQuery = useQuery(
		[MFA_SESSION_SUMMARY, sessionId],
		async (): Promise<SummaryPaneResult> =>
			getSessionSummary({
				sessionId
			})
	);

	return sessionSummaryQuery;
};
